// src/hooks/useSendMessage.js
import { useMutation } from "@tanstack/react-query";
import { sendMessageApi } from "api/sendMessageApi";

export const useSendMessage = () => {
  return useMutation({
    mutationFn: sendMessageApi,
    onSuccess: (data) => {
      console.log("✅ Message API success:", data);
    },
    onError: (error) => {
      console.error("❌ Message API error:", error.message);
    },
  });
};
